import React, { useEffect, useState } from "react";
import Frame from "react-frame-component";
import { openLink, getSelectors } from "../utils/helpers";
import SizeSelector from "../utils/size-selector";

const selectorMap = [
  { icon: "desktop", key: "desktop", title: "Desktop" },
  { icon: "tablet", key: "tablet", title: "Tablet" },
  { icon: "mobile-slim", key: "mobile", title: "Mobile" },
];

const StageBanner = ({ banner }) => {
  const [selectorIcons, setSelectorIcons] = useState([]);

  useEffect(() => {
    getSelectors(banner, selectorMap).then((icons) => {
      setSelectorIcons(icons);
    });
  }, [banner]);

  const url = encodeURIComponent(banner.bannerURL);

  return (
    <SizeSelector selectors={selectorIcons}>
      <Frame
        initialContent={`<!DOCTYPE html><html><head><link
          href="${process.env.PUBLIC_URL}/static/css/simple-brand.css?v=2"
          rel="stylesheet"
        /></head><body><div id="bannerFrame"></div></body></html>`}
        mountTarget="#bannerFrame"
      >
        <div className="wrapper">
          <div className="img-container">
            <a
              href={banner.bannerURL}
              target={banner.openLinkOptions}
              id="ref"
              onClick={(e) => openLink(e, url)}
            >
              <picture>
                <source
                  media="(min-width: 981px)"
                  srcSet={`${banner.desktop.path} 1280w`}
                />
                <source
                  media="(min-width: 481px)"
                  srcSet={`${banner.tablet.path} 980w`}
                />
                <source
                  media="(min-width: 200px)"
                  srcSet={`${banner.mobile.path} 480w`}
                />
                <img alt={banner.alt} id="bannerImg" src={banner.mobile.path} />
              </picture>
            </a>
          </div>
        </div>
      </Frame>
    </SizeSelector>
  );
};

export default StageBanner;
